// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--a2fe4";
export var footerNav = "footer-module--footerNav--a84d6";
export var socialLinksNav = "footer-module--socialLinksNav--ca7dd";
export var wrapper = "footer-module--wrapper--88066";